import { render, staticRenderFns } from "./SingleProductListHasTags.vue?vue&type=template&id=33a46f4c&"
import script from "./SingleProductListHasTags.vue?vue&type=script&lang=js&"
export * from "./SingleProductListHasTags.vue?vue&type=script&lang=js&"
import style0 from "./SingleProductListHasTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports